@if (details(); as d) {
  <div class="details-body flex flex-column gap-4">
    <!-- STATUS -->
    @if (state() === 'cancelled') {
      <div class="cancelled-banner flex align-items-center gap-3 p-3">
        <div class="banner-icon flex justify-content-center align-items-center">
          <app-slash-circle-01 stroke="#F04438"></app-slash-circle-01>
        </div>
        <div class="flex flex-column gap-1">
          <p-chip label="Otkazan" styleClass="red sm"></p-chip>
          @if (d.from) {
            <div class="text-sm-medium text-gray-700">{{ getDateFormatedSrWithTime(d.from) }}</div>
          }
        </div>
      </div>
    } @else {
      <div class="w-full">
        <p-chip
          [label]="state() === 'noShow' ? 'Nije se pojavio' : (state() === 'completed' ? 'Završen' : (d.status?.description ?? 'Zakazan'))"
          [styleClass]="statusChipClass()"
        ></p-chip>
      </div>
    }

    <!-- SVI DETALJI -->
    <div class="flex flex-column gap-3">
      <div class="text-md-semibold text-gray-900">Svi detalji</div>
      <div class="flex align-items-center justify-content-between">
        <div class="flex">
          <app-calendar stroke="#ADB0B8"></app-calendar>
          <div class="ml-2 text-sm-regular text-gray-600">Datum</div>
        </div>
        <div class="text-sm-medium text-gray-700">{{ getDateFormatedSrLong(d.from!) }}</div>
      </div>
      <div class="flex align-items-center justify-content-between">
        <div class="flex">
          <app-clock stroke="#ADB0B8"></app-clock>
          <div class="ml-2 text-sm-regular text-gray-600">Vreme</div>
        </div>
        <div class="text-sm-medium text-gray-700">{{ formatTimeRange(d.from!, d.to!) }}</div>
      </div>
      <div class="flex align-items-center justify-content-between">
        <div class="flex">
          <app-hourglas-03 stroke="#ADB0B8"></app-hourglas-03>
          <div class="ml-2 text-sm-regular text-gray-600">Trajanje</div>
        </div>
        <div class="text-sm-medium text-gray-700">{{ d.duration }}h</div>
      </div>
    </div>

    <!-- PLAN PROJEKCIJE -->
    @if (d.documents && d.documents.length > 0) {
      <div class="flex flex-column gap-3">
        <div class="text-md-semibold text-gray-900">Plan projekcije</div>
        @for (doc of d.documents; track trackDoc($index, doc)) {
          <div class="file-row flex align-items-center justify-content-between gap-3 p-3">
            <div class="flex gap-2">
              @if (doc.type === FileType.PDF) {
                <app-pdf height="40px" width="32px"></app-pdf>
              } @else {
                <app-dwg height="40px" width="32px"></app-dwg>
              }
              <div class="flex flex-column flex-1">
                <div class="text-sm-medium text-gray-700">{{ doc.name }}</div>
                <div class="text-sm-regular text-gray-600">{{ formatFileSize(doc.size) }}</div>
              </div>
            </div>
            <app-button
              [btnSize]="ButtonSize.SM"
              [btnSeverity]="ButtonSeverity.TERTIARY"
              [isBtnDisabled]="!doc.downloadUrl"
              (btnClicked)="download(doc)"
            >
              <app-download-01 stroke="#2970FF"></app-download-01>
            </app-button>
          </div>
        }
      </div>
    }

    <!-- KLIJENT -->
    @if (d.client; as client) {
      <div class="flex flex-column gap-3">
        <div class="text-md-semibold text-gray-900">Klijent</div>
        <div class="flex align-items-center gap-3">
          <div class="detail-icon flex justify-content-center align-items-center">
            @if (client.isCompany) {
              <app-building-05 stroke="#414651"></app-building-05>
            } @else {
              <app-user-circle stroke="#414651"></app-user-circle>
            }
          </div>
          <div class="flex flex-column flex-1">
            <div class="text-sm-medium text-gray-900">{{ client.fullName }}</div>
            <div class="text-xs-medium text-gray-500">{{ client.isCompany ? 'Pravno lice' : 'Fizičko lice' }}</div>
          </div>
          <div class="flex align-items-center gap-1 cursor-pointer view-profile-link" (click)="handleViewClient()">
            <div class="text-sm-semibold">Vidi profil</div>
            <app-arrow direction="right" stroke="#1570EF"></app-arrow>
          </div>
        </div>
      </div>
    }
  </div>

  @if (!hideActions()) {
    @if (state() === 'scheduled') {
      <div class="details-footer flex align-items-center justify-content-between gap-3 p-4">
        <app-button
          [btnSeverity]="ButtonSeverity.SECONDARY"
          [btnSize]="ButtonSize.MD"
          [isDestructive]="true"
          btnClass="flex-1"
          (btnClicked)="handleCancel()"
        >
          <app-slash-circle-01 stroke="#D92D20"></app-slash-circle-01>
          <div class="text-sm-semibold text-red-600">Otkaži</div>
        </app-button>
        @if (!details()?.isShortNotice) {
          <app-button
            [btnSeverity]="ButtonSeverity.SECONDARY"
            [btnSize]="ButtonSize.MD"
            btnClass="flex-1"
            (btnClicked)="handleEdit()"
          >
            <app-edit-03 stroke="#181D27"></app-edit-03>
            <div class="text-sm-semibold text-gray-900">Izmeni</div>
          </app-button>
        }
      </div>
    } @else if (canMarkNoShow()) {
      <div class="details-footer flex align-items-center justify-content-between gap-3 p-4">
        <app-button
          [btnSeverity]="ButtonSeverity.SECONDARY"
          [btnSize]="ButtonSize.MD"
          btnClass="flex-1"
          (btnClicked)="handleMarkNoShow()"
        >
          <app-alert-triangle stroke="#181D27"></app-alert-triangle>
          <div class="text-sm-semibold text-gray-900">Označi kao nedolazak</div>
        </app-button>
      </div>
    }
  }
}

@if (details(); as d) {
  <p-dialog
    [(visible)]="showCancelDialog"
    [modal]="true"
    [closable]="false"
    appendTo="body"
    [baseZIndex]="20000"
    [style]="{ width: '25rem' }"
  >
    <div class="flex flex-column">
      <div class="text-lg-semibold text-gray-900">Otkažite termin</div>
      <div class="mt-1 text-sm-regular text-gray-600">
        Da li ste sigurni da želite da otkažete termin korisnika {{ d.client?.fullName }}?
      </div>
    </div>
    <ng-template #header>
      <div class="flex align-items-center justify-content-between w-full">
        <div class="flex justify-content-center align-items-center dialog-header-icon">
          <app-slash-circle-01 stroke="#414651" width="20px" height="20px"></app-slash-circle-01>
        </div>
        <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="closeCancelDialog()"></app-x-close>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="flex justify-content-end align-items-center w-full">
        <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="closeCancelDialog()">
          <div class="text-sm-semibold text-gray-900">Odustani</div>
        </app-button>
        <app-button class="ml-2-5" [isDestructive]="true" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="confirmCancel()">
          <div class="text-sm-semibold text-white">Otkaži termin</div>
        </app-button>
      </div>
    </ng-template>
  </p-dialog>
}

<app-appointment-reschedule-dialog
  [(visible)]="showRescheduleDialog"
  [appointmentId]="appointmentId()"
  (rescheduled)="onRescheduleSuccess($event)"
></app-appointment-reschedule-dialog>

@if (details(); as d) {
  <p-dialog
    [(visible)]="showNoShowDialog"
    [modal]="true"
    [closable]="false"
    appendTo="body"
    [baseZIndex]="20000"
    [style]="{ width: '25rem' }"
  >
    <div class="flex flex-column">
      <div class="text-lg-semibold text-gray-900">Označi kao nedolazak</div>
      <div class="mt-1 text-sm-regular text-gray-600">
        Da li ste sigurni da želite da označite termin korisnika {{ d.client?.fullName }} kao nedolazak?
      </div>
    </div>
    <ng-template #header>
      <div class="flex align-items-center justify-content-between w-full">
        <div class="flex justify-content-center align-items-center dialog-header-icon">
          <app-alert-triangle stroke="#414651" width="20px" height="20px"></app-alert-triangle>
        </div>
        <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="closeNoShowDialog()"></app-x-close>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="flex justify-content-end align-items-center w-full">
        <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="closeNoShowDialog()">
          <div class="text-sm-semibold text-gray-900">Odustani</div>
        </app-button>
        <app-button class="ml-2-5" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="confirmMarkNoShow()">
          <div class="text-sm-semibold text-white">Potvrdi</div>
        </app-button>
      </div>
    </ng-template>
  </p-dialog>
}
